export default {"src":"/_next/static/media/forbes.65f2afdf.svg","height":54,"width":200,"blurWidth":0,"blurHeight":0};